import { c as _c } from "react/compiler-runtime";
import { HoldingShape } from "@repo/ui/holding-shape";
import { SolidShape } from "@repo/ui/solid-shape";
import { cn } from "@repo/ui/utils";
import { stegaClean } from "next-sanity";
import { VisualWrapper } from "@/components/common/visual/visual.component";
import { MarketingPopupClose } from "./marketing-popup-close.component";
import { MarketingPopupContent } from "./marketing-popup-content.component";
import { popupVisual } from "./marketing-popup.types";
import type { MarketingPopupVariantProps } from "./marketing-popup.types";
export function MarketingPopupSignatureShape(t0) {
  const $ = _c(19);
  const {
    popup,
    className,
    onClose,
    onCtaClick
  } = t0;
  let t1;
  if ($[0] !== popup.maskedImage) {
    t1 = stegaClean(popup.maskedImage);
    $[0] = popup.maskedImage;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const cleanMaskedImage = t1;
  const shape = !cleanMaskedImage || cleanMaskedImage === "none" ? "arch" : cleanMaskedImage;
  let t2;
  let visual;
  if ($[2] !== className || $[3] !== popup) {
    visual = popupVisual(popup);
    t2 = cn("dark relative grid w-full max-w-2xl gap-6 overflow-hidden rounded-md bg-surface-base-primary p-6 tablet:p-10", visual && "tablet:grid-cols-[3fr_2fr]", className);
    $[2] = className;
    $[3] = popup;
    $[4] = t2;
    $[5] = visual;
  } else {
    t2 = $[4];
    visual = $[5];
  }
  let t3;
  if ($[6] !== onClose) {
    t3 = <MarketingPopupClose onClick={onClose} />;
    $[6] = onClose;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== onCtaClick || $[9] !== popup) {
    t4 = <MarketingPopupContent popup={popup} className="self-center" onCtaClick={onCtaClick} />;
    $[8] = onCtaClick;
    $[9] = popup;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== shape || $[12] !== visual) {
    t5 = visual && <div className="relative self-center"><SolidShape variant="circle" color="peach" className="absolute -left-2 top-4 z-10 w-8" /><SolidShape variant="circle" color="turquoise" className="absolute -right-1 bottom-6 z-10 w-5" /><HoldingShape variant={shape} className="w-full"><VisualWrapper visual={visual} className="h-full w-full" visualClassName="h-full w-full" imgClassName="h-full w-full object-cover" asBackground={true} /></HoldingShape></div>;
    $[11] = shape;
    $[12] = visual;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t2 || $[15] !== t3 || $[16] !== t4 || $[17] !== t5) {
    t6 = <article className={t2} data-testid="marketing-popup-signature-shape">{t3}{t4}{t5}</article>;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
}